import { RegEx } from "/imports/api/_jsonSchemas/schemas/components/_all";

export default {
  type: "object",
  properties: {
    company: { type: "string" },
    partnerId: { type: "string" },
    isAddingNew: { type: "boolean" },
    isSelected: { type: "boolean" },
    sendInvite: { type: "boolean" },
    email: { type: "string", pattern: RegEx.Email.source }, // if send invite flag
    firstName: { type: "string" }, // if send invite flag
    lastName: { type: "string" }, // if send invite flag
    type: { type: "string", enum: ["shipper", "carrier", "provider"] },
    role: { type: "string", enum: ["warehouse", "forwarder", "customs"] }
  },

  required: ["company", "type"],
  errorMessage:{
    properties: {
      email: "Email should be a valid email address",
    }
  }
}